exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chat-app[data-v-56675fe8] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}", ""]);

// exports
